/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Exclude from T those types that are assignable to U
 */
export enum Exclude_CustomFieldEntityType_PROPERTY_ {
    CONTACT = 'CONTACT',
    COMPANY = 'COMPANY',
    FUNNEL_CONVERSATION = 'FUNNEL_CONVERSATION',
    FUNNEL_CHANNEL_SESSION = 'FUNNEL_CHANNEL_SESSION',
    PRODUCT = 'PRODUCT',
}
